import Axios from "@/Axios";

class HoldReasonService{

    async getHoldReason(data={}){
        return await Axios.get('wms.wms.api.hold_reason.get_hold_reasons',{
            params:data
        })
    }
    async createHoldReason(data){
        console.log("in data",data)
      return await Axios.post('wms.wms.api.hold_reason.create_hold_reason',data)
    }
    async deleteHoldReason(holdstatus){
        console.log("holdstatus",holdstatus)
        const transformedholdReason = holdstatus.map(item => ({ name: item }));
        return await Axios.delete('wms.wms.api.hold_reason.delete_hold_reasons',{data:{holdstatus:transformedholdReason}})
    }

}
export default  new HoldReasonService()